import { combineEpics } from 'redux-observable';
import applicationEpic from 'application/applicationEpic';
import submissionEpic from 'submission/submissionEpic';
import introductionEpic from 'introduction/introductionEpic';
import optionsEpic from 'options/optionsEpic';
import contactInfoEpic from 'contact-info/contactInfoEpic';
import dissertationInfoEpic from 'dissertation-info/dissertationInfoEpic';
import fileUploadEpic from 'file-upload/fileUploadEpic';

export default combineEpics(
  applicationEpic,
  submissionEpic,
  introductionEpic,
  optionsEpic,
  contactInfoEpic,
  dissertationInfoEpic,
  fileUploadEpic,
);



// WEBPACK FOOTER //
// ./src/root/rootEpic.js